import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Stepper from "./stepper";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

const Step4 = ({
  prevStep,
  nextStep,
  handleChange,
  options,
  validStates,
  values,
}) => {
  const { t } = useTranslation("global");
  const {
    register,
    trigger,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const Previous = (e) => {
    e.preventDefault();
    prevStep();
    navigate(
      `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=vehicles`
    );
  };

  const Continue = (e) => {
    e.preventDefault();

    // validate fields
    trigger().then((r) => {
      // if fields completed as required, move to next step
      if (r === true) {
        nextStep();
        navigate(
          `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=coverage`
        );
      }
    });
  };

  const addSelectOptions = (fieldPosition) => {
    // see: https://stackoverflow.com/a/36206330/11748942
    // console.log(options);
    let opts = [];
    opts.push(
      <option value="">{t("step4.form.selectors.defaultOption")}</option>
    ); // default option
    var list;
    validStates.forEach((validState) => {
      if (values.stateCode === validState) {
        list = options.enums[fieldPosition].enum.state[validState];
      }
    });
    // if (values.stateCode === 'TX') { list = options.enums[fieldPosition].enum.state.TX; }

    // if (values.stateCode === 'CA') { list = options.enums[fieldPosition].enum.state.CA; }
    // if (values.stateCode === 'CO') { list = options.enums[fieldPosition].enum.state.CO; }
    // if (values.stateCode === 'CT') { list = options.enums[fieldPosition].enum.state.CT; }
    // if (values.stateCode === 'GA') { list = options.enums[fieldPosition].enum.state.GA; }
    // if (values.stateCode === 'PA') { list = options.enums[fieldPosition].enum.state.PA; }
    // if (values.stateCode === 'FL') { list = options.enums[fieldPosition].enum.state.FL; }

    for (let i = 0; i < list.length; i++) {
      // spanish options
      if (values.language === "es" && list[i].spanish_name) {
        opts.push(
          <option key={list[i].id} value={list[i].id}>
            {list[i].spanish_name}
          </option>
        ); // Keys are needed?
      } else {
        // english options
        if (fieldPosition !== 8) {
          opts.push(
            <option key={list[i].id} value={list[i].id}>
              {list[i].name}
            </option>
          ); // Keys are needed?
        } else {
          opts.push(
            <option key={list[i].id} value={list[i].name}>
              {list[i].name}
            </option>
          ); // Keys are needed?
        }
      }
    }
    return opts;
  };

  return (
    <Container style={{ marginTop: "2%" }}>
      <Row>
        <Col lg={3}></Col>
        <Col lg={7}>
          <div className="page-texts">
            <p className="title">{t("step4.page.title")}</p>
            <p className="subtitle">{t("step4.page.subtitle")}</p>
          </div>
        </Col>
      </Row>

      <Row style={{ marginTop: "1rem" }}>
        <Col lg={3}>
          <Stepper step="3" t={t}></Stepper>
        </Col>
        <Col lg={7}>
          <div className="form-texts">
            <p className="title" style={{ color: "#253244" }}>
              {t("step4.form.title")}
            </p>
            <p className="subtitle" style={{ color: "#253244" }}>
              {t("step4.form.subtitle")}
            </p>
          </div>

          <Form>
            <Form.Group style={{ width: "70%", textAlign: "left" }}>
              <Form.Label className="question-title">
                {t("step4.form.usage.title")}
              </Form.Label>
              <Form.Label className="question-subtitle">
                {t("step4.form.usage.subtitle")}
              </Form.Label>
              <Form.Select
                {...register("usage", { required: true })}
                value={values.usage}
                onChange={handleChange("usage")}
              >
                {addSelectOptions(3)}
              </Form.Select>
              {errors.usage && (
                <p className="require-field-message">
                  {t("requiredFieldMessage")}
                </p>
              )}
            </Form.Group>
            <br />
            <br />

            {/* <Form.Group style={{ width: "70%", textAlign: "left" }}>
              <Form.Label className="question-title">
                {t("step4.form.ageDriver.title")}
              </Form.Label>
              <Form.Label className="question-subtitle">
                {t("step4.form.ageDriver.subtitle")}
              </Form.Label>
              <Form.Select
                {...register("ageDriver", { required: true })}
                value={values.ageDriver}
                onChange={handleChange("ageDriver")}
              >
                {addSelectOptions(4)}
              </Form.Select>
              {errors.ageDriver && (
                <p className="require-field-message">
                  {t("requiredFieldMessage")}
                </p>
              )}
            </Form.Group> */}
            <Form.Group style={{ width: "70%", textAlign: "left" }}>
              <Form.Label>{t("step4.form.ageDriver.title")}</Form.Label>
              <Form.Control
                {...register("ageDriver", { required: true })}
                value={values.ageDriver}
                onChange={handleChange("ageDriver")}
                type="text"
              />
              {errors.ageDriver && (
                <p className="require-field-message">
                  {t("requiredFieldMessage")}
                </p>
              )}
            </Form.Group>

            <br />
            <br />

            <Form.Group style={{ width: "70%", textAlign: "left" }}>
              <Form.Label className="question-title">
                {t("step4.form.accidentsOrTickets.title")}
              </Form.Label>
              <Form.Label className="question-subtitle">
                {t("step4.form.accidentsOrTickets.subtitle")}
              </Form.Label>
              <Form.Select
                {...register("accidentsOrTickets", { required: true })}
                value={values.accidentsOrTickets}
                onChange={handleChange("accidentsOrTickets")}
              >
                {addSelectOptions(5)}
              </Form.Select>
              {errors.accidentsOrTickets && (
                <p className="require-field-message">
                  {t("requiredFieldMessage")}
                </p>
              )}
            </Form.Group>
            <br />
            <br />

            <Row>
              <Col lg={4}>
                <Link
                  to={`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=vehicles`}
                >
                  <Button
                    variant="outline-dark"
                    onClick={Previous}
                    style={{ width: "100%" }}
                  >
                    {t("step4.form.prevButton")}
                  </Button>
                </Link>
              </Col>
              <Col lg={5}>
                <Link
                  to={`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=coverage`}
                >
                  <Button
                    variant="success"
                    onClick={Continue}
                    style={{ width: "100%" }}
                  >
                    {t("step4.form.nextButton")}
                  </Button>
                </Link>
              </Col>
            </Row>
            <br />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Step4;
